import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sessionId = new URLSearchParams(location.hash.slice(1)).get("session_id");
    api.google(sessionId)
      .then((u) => { setUser(u); navigate("/coach", { replace: true }); })
      .catch((e) => { toast.error(formatApiError(e)); setUser(false); navigate("/login", { replace: true }); });
  }, [location.hash, navigate, setUser]);

  return null;
}
